"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    resizable: {
        type: Boolean,
        default: undefined
    },
    items: {
        type: Array,
        default: undefined
    },

    // Events
    click: {
        type: Function,
        default: undefined
    },
    close: {
        type: Function,
        default: undefined
    },
    open: {
        type: Function,
        default: undefined
    },
    toggle: {
        type: Function,
        default: undefined
    },
    overflowClose: {
        type: Function,
        default: undefined
    },
    overflowOpen: Function
};